import { ChevronDown } from "lucide-react";
import type { Document, DocumentInput } from "@/lib/types";
import { SavedTextarea } from "./Fields";

export function TextsSection({ doc, save }: { doc: Document; save: (input: DocumentInput) => Promise<unknown> }) {
  return (
    <details className="group/texts rounded-xl border bg-card px-4">
      <summary className="flex min-h-12 cursor-pointer list-none flex-wrap items-center gap-x-2 rounded-md py-2 outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 [&::-webkit-details-marker]:hidden">
        <span className="text-[0.9375rem] font-semibold">Texte</span>
        <span className="text-[0.8125rem] text-muted-foreground">Einleitung und Schluss wie immer · Kleinunternehmer-Hinweis fix</span>
        <ChevronDown aria-hidden className="ml-auto size-3.5 text-muted-foreground transition-transform duration-150 group-open/texts:rotate-180 motion-reduce:transition-none" />
      </summary>
      <div className="flex flex-col gap-3.5 pb-4">
        <SavedTextarea label="Einleitung" value={doc.intro} save={(intro) => save({ intro })} />
        <SavedTextarea label="Schluss" value={doc.closing} save={(closing) => save({ closing })} />
        <p className="text-xs text-muted-foreground">{doc.taxNote}</p>
      </div>
    </details>
  );
}
